import React from 'react';

interface ListItemType {
  children: React.ReactNode;
}

const ListItem = ({ children }: ListItemType) => {
  return <div className='text-white flex items-center justify-between border-b-2 border-black'>{children}</div>;
};

export default ListItem;
